export default "__VITE_ASSET__D_9w0TdI__"